import React from "react";
import {observer} from "mobx-react";
import {IStandardDropDownListViewModel} from "../list-view/models/list/standard-drop-down-list-view-model.interface";
import {useServices} from "../../../../hooks/use-services.hook";
import {IDropDownController} from "../../drop-down/models/drop-down-controller.interface";
import {ActionsSheetComponent} from "../../../../basic-components/action-sheet/action-sheet.component";


interface StandardDropDownActionSheetViewComponentProps<TFieldValue> {
    listViewModel: IStandardDropDownListViewModel<TFieldValue>;
    dropDownController: IDropDownController;
    label?: string;
}

interface ActionSheetButton {
    text: string,
    data: any;
    handler: () => void;
}

export const StandardDropDownActionSheetComponent = observer(<TFieldValue extends any>(props: StandardDropDownActionSheetViewComponentProps<TFieldValue>) => {
    const services = useServices();

    const actionSheetButtons: ActionSheetButton[] = [];
    for(let i of props.listViewModel.filteredItems) {
        actionSheetButtons.push({
            text: i.getDisplayText(),
            data: i,
            handler: () => {
                props.listViewModel.setSelectedItem(i)
            }
        });
    }

    if(actionSheetButtons.length === 0) {
        return null;
    }

    actionSheetButtons.push({
        text: services.language.translate('Cancel'),
        data: null,
        handler: () => {
            props.dropDownController.closeDropDown();
        }
    });

    return (
        <ActionsSheetComponent >
            {actionSheetButtons.map(b => <div key={b.text}>{b.text}</div>)}
        </ActionsSheetComponent>
    );
});

